import SelectBox from "devextreme-react/select-box";
import React, { useEffect, useState, useSelector } from 'react';
import { userApi } from '../../api/userApi';
import { useCommonContext } from '../../contexts/common';

const SelectUserPheDuyet = ({
    value,
    onValueChanged,
    showClearButton,
    widthCustom, dm_coso_id1
}) => {
    const { translate } = useCommonContext();
    const [user_pheduyets, set_user_pheduyets] = useState([]);

    useEffect(() => {
        (async () => {
            // onValueChanged([]);
            const res = await userApi.SelectUserPheDuyet(dm_coso_id1);
            if (res.is_success) {
                res.data = res.data.map(item => ({
                    ...item,
                    customDisplay: `${item.full_name} (${item.email} - ${item.phone_number})`
                }))
                set_user_pheduyets(res.data);
            } else {
                set_user_pheduyets([]);
            }
        })();
    }, []);
    const containerStyle = {
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
    };

    return (
        <div
            style={containerStyle}
        >
            <SelectBox
                items={user_pheduyets}
                showSelectionControls={true}
                searchEnabled
                displayExpr={'customDisplay'}
                valueExpr={'id'}
                value={value}
                multiline={false}
                stylingMode="outlined"
                width={widthCustom}
                placeholder={translate('Chọn người phê duyệt')}
                showClearButton={showClearButton}
                height={'auto'}
                onValueChanged={(e) => {
                    onValueChanged(e.value);
                }}
            />
        </div>
    );
};

export default SelectUserPheDuyet;
